// extracted by mini-css-extract-plugin
export default {"root":"ToastNotification-root","body":"ToastNotification-body","message":"ToastNotification-message"};